import React, { useCallback } from "react";
import { Box, Grid, GridItem, SimpleGrid, Text } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import CriancaService from "../../../../../main/services/CriancaService";
import { OcorrenciasTable } from "../Table";
import { CustomButton } from "../../../../components/CustomButton";
import { useHistory } from "react-router";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import {
  Permission,
  criancaFunc,
  ocorrenciasFunc,
} from "../../../../../helpers/Funcionalidades";
import SemRegistros from "../../../../components/SemRegistros";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import Swal from "sweetalert2";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { useAuthProvider } from "../../../../../Context/AuthProvider";

export const VisualizarPageOcorrencias = ({
  id,
  setIsTrueVisualizar,
  props,
  setInitialValues,
  setLoadingPainel,
  user,
  idPJ,
}) => {
  const { values } = useFormikContext();
  const [data, setData] = useState([]);
  const [dataDefault, setDataDefault] = useState([]);
  const history = useHistory();
  const { roleKeycloack } = useAuthProvider();
  const [tipoOcorrencias, setTipoOcorrencias] = useState({
    options: [],
    isLoading: false,
  });
  const [loadingOcorrencias, setLoadingOcorrencia] = useState(false);
  const [isDataInitialized, setIsDataInitialized] = useState(false);

  const columns = [
    {
      Header: "Data",
      accessor: "dataOcorrencia",
      Cell: (props) => {
        const custom_date = new Date(props.value).toLocaleDateString("pt-BR");
        return <span>{custom_date}</span>;
      },
    },
    {
      Header: "Tipo da Ocorrência",
      accessor: "tipoOcorrencia",
      sortType: (rowA, rowB, columnId) => {
        const descricaoA = rowA.original.tipoOcorrencia.descricao;
        const descricaoB = rowB.original.tipoOcorrencia.descricao;

        return descricaoA.localeCompare(descricaoB, undefined, {
          sensitivity: "base",
        });
      },
      Cell: (props) => {
        return <span>{props.value?.descricao}</span>;
      },
    },
    {
      Header: "Responsável",
      accessor: "nomeResponsavelOcorrencia",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Descrição/Justificativa",
      accessor: (row) => {
        return row;
      },
      sortType: (rowA, rowB, columnId) => {
        const textA =
          rowA.original.descricaoOcorrencia ||
          rowA.original.justificativaOcorrencia ||
          "";
        const textB =
          rowB.original.descricaoOcorrencia ||
          rowB.original.justificativaOcorrencia ||
          "";

        return textA.localeCompare(textB, undefined, { sensitivity: "base" });
      },
      Cell: (props) => {
        return (
          <span style={{ wordBreak: "break-all" }}>
            {props?.value?.descricaoOcorrencia
              ? props?.value?.descricaoOcorrencia
              : props?.value?.justificativaOcorrencia
              ? props?.value?.justificativaOcorrencia
              : ""}
          </span>
        );
      },
    },
  ];

  const handleGetTipoOcorrencias = () => {
    setTipoOcorrencias({
      ...tipoOcorrencias,
      isLoading: true,
    });

    CriancaService.getTipoOcorrencias().then((res) => {
      const tempOptions = res.data.map((ocorrencia) => {
        return {
          id: ocorrencia.id,
          descricao: ocorrencia.descricao,
        };
      });
      setTipoOcorrencias({
        options: tempOptions,
        isLoading: false,
      });
    });
  };

  const fetchData = useCallback(() => {
    setLoadingOcorrencia(true);
    CriancaService.getOcorrencias(id)
      .then((res) => {
        const rawData = res.data;

        const filteredData = rawData.filter((ocorrencia) => {
          const isTipoMatch =
            !values.tipoSearch ||
            ocorrencia.tipoOcorrencia.id === values.tipoSearch.id;

          const dataOcorrencia = new Date(ocorrencia.dataOcorrencia);

          const dataSearch1 = values.dataSearch1
            ? parseDate(values.dataSearch1)
            : null;

          const dataSearch2 = values.dataSearch2
            ? parseDate(values.dataSearch2)
            : null;

          if (dataSearch2) {
            dataSearch2.setHours(23, 59, 59, 999);
          }

          const isDateMatch =
            (!dataSearch1 || dataOcorrencia >= dataSearch1) &&
            (!dataSearch2 || dataOcorrencia <= dataSearch2);

          return isTipoMatch && isDateMatch;
        });

        const finalData =
          values.tipoSearch || values.dataSearch1 || values.dataSearch2
            ? filteredData
            : rawData;

        finalData.sort((a, b) => {
          const dateA = new Date(a.dataOcorrencia);
          const dateB = new Date(b.dataOcorrencia);
          return dateB - dateA;
        });

        setData(finalData);
        setDataDefault(res.data);
        setLoadingOcorrencia(false);
        setLoadingPainel(true);
        setIsDataInitialized(true);
      })
      .catch((err) => {
        console.log("Erro no get de ocorrencia");
        setIsTrueVisualizar(false);
        setLoadingOcorrencia(false);
        setIsDataInitialized(true);
      });
  }, [
    id,
    setIsTrueVisualizar,
    setLoadingPainel,
    values.dataSearch1,
    values.dataSearch2,
    values.tipoSearch,
  ]);

  function parseDate(dateString) {
    const [day, month, year] = dateString.split("/");
    const parsedDate = new Date(`${year}-${month}-${day}`);

    const utcDate = new Date(
      parsedDate.getTime() + parsedDate.getTimezoneOffset() * 60000
    );
    return utcDate;
  }

  useEffect(() => {
    fetchData();
  }, [values.tipoSearch, values.dataSearch1, values.dataSearch2, fetchData]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    if (
      isDataInitialized &&
      dataDefault.length <= 0 &&
      (roleKeycloack?.includes(ocorrenciasFunc.visualizar) ||
        ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
          user?.orgaoExterno?.includes(idPJ)))
    ) {
      history.push(`/crianca/cadastrar-ocorrencias/${id}`);
    }
  }, [
    dataDefault,
    isDataInitialized,
    id,
    history,
    roleKeycloack,
    user?.orgaoExterno,
    idPJ,
  ]);

  const deleteOcorrencia = (idOcorrencia, onClose) => {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja realmente excluir a ocorrência?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169499",
      cancelButtonColor: "#169499",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((result) => {
      if (result.isConfirmed) {
        CriancaService.deleteOcorrencias(id, idOcorrencia)
          .then((res) => {
            Swal.fire({
              title: "Sucesso!",
              text: "Registro Excluído.",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then((result) => {});
            onClose();
            fetchData();
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error?.response?.data?.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }
    });
  };

  return (
    <Group title="Ocorrências">
      <SimpleGrid
        mt="30px"
        columns={{ base: 1, sm: 2, lg: 5 }}
        spacing="20px"
        marginTop={"-50px"}
        dir="rtl"
      >
        <Permission
          roleKeycloack={roleKeycloack}
          func={ocorrenciasFunc.incluir}
          user={user}
          id={idPJ}
          visualizar={true}
        >
          <CustomButton
            label="Cadastrar"
            onClick={() => {
              history.push(`/crianca/cadastrar-ocorrencias/${id}`);
            }}
          />
        </Permission>
      </SimpleGrid>
      <Grid
        templateColumns="repeat(5, 1fr)"
        mt={
          roleKeycloack &&
          (roleKeycloack?.includes(ocorrenciasFunc.incluir) ||
            ((roleKeycloack?.includes(criancaFunc.incluirTudoAcolhimento) ||
              roleKeycloack?.includes(criancaFunc.incluirTudoTutelar)) &&
              user?.orgaoExterno?.includes(idPJ)))
            ? 4
            : 16
        }
        gap={10}
        mb={4}
      >
        <GridItem colSpan={2}>
          <CustomSelectWField
            fieldName="tipoSearch"
            placeholder="Selecione o tipo"
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            isLoading={tipoOcorrencias.isLoading}
            options={tipoOcorrencias.options}
            onChange={(value) => {
              props.setFieldValue("tipoSearch", value ? value : "");
            }}
            onFocus={
              tipoOcorrencias.options.length === 0
                ? handleGetTipoOcorrencias
                : null
            }
          />
        </GridItem>
        <GridItem colSpan={3} display={"flex"} gap={6} alignItems={"center"}>
          <Box w={{ m: "0" }}>
            <CustomDatepickerWField
              fieldName="dataSearch1"
              placeholder="DD/MM/AAAA"
            />
          </Box>

          <Text>até</Text>

          <Box w={{ m: 0 }}>
            <CustomDatepickerWField
              fieldName="dataSearch2"
              placeholder="DD/MM/AAAA"
            />
          </Box>
        </GridItem>
      </Grid>
      {!loadingOcorrencias ? (
        <>
          {data && data.length > 0 ? (
            <OcorrenciasTable
              columns={columns}
              data={data}
              entidade={"ocorrencias"}
              setInitialValues={setInitialValues}
              setIsTrueVisualizar={setIsTrueVisualizar}
              roleKeycloack={roleKeycloack}
              deleteOcorrencia={deleteOcorrencia}
              idPJ={idPJ}
              user={user}
            />
          ) : (
            <Box mt="2">
              <SemRegistros half buttonVisible={true} />
            </Box>
          )}
        </>
      ) : (
        <LoadingSpinner />
      )}
    </Group>
  );
};
